/* global utilities, log, waldirApp, gsap */
(function f(u) {
    const { qs, qsa, each, addEvent, addClass, removeClass, hasClass, toggleClass, trigger, createElement, docReady, newFetch } = u;
    const { ajaxurl, restApi } = waldirApp;

    const ELS = {
        body:                   document.body,
        locationSelect:         qs('#locationSelect'),
        languageSelectUSCanada: qs('#languageSelectUSCanada'),
        languageSelectOUS:      qs('#languageSelectOUS'),
        unhideSelect:           qsa('.unhide-select'),
    };

    ELS.unhideSelect.forEach((select) => {
        select.addEventListener('change', function f() {
            const all      = this.dataset.all;
            const selected = qs(`#${this.value}`);
            gsap.set(all, { display: 'none' });

            console.log(all);

            if (!this.value || !selected) return;

            gsap.fromTo(selected, { opacity: 0 }, {
                opacity:  1,
                display:  'block',
                duration: 0.5,
                onComplete() {
                    selected.focus();
                },
            });
        });
    });

 	// $('.docDisclaimer').hide();
    // $('.OUSInt .all').hide();
    // $('.OUSInt #selectForm').change(function (event) {
    //     $('.all').hide();
    //     toggleLanguage('OUSInt', this.value);
    // });


    // $('.USSect .all').hide();
    // $('.USSect #selectForm').change(function (event) {
    //     $('.all').hide();
    //     toggleLanguage('USSect', this.value);
    // });

    // function toggleLanguage(sect, language) {
    //     if (language == 'all')
    //         return;
    //     $(`.${sect} .${language}`).fadeIn('slow');
    //     $('.docDisclaimer').fadeIn('slow');
    //     console.log((`.${sect} .${language}`));
    // }


    if (typeof LP !== 'undefined') {
        LP.Hook.addAction('course-ready', () => {
            console.log('course ready');
            LP.Hook.addAction('lp-compatible-builder', (e) => {
                console.log('quiz compatible builder', e);
            });
        });
    }


    /**
 * Initiate the stuff
 */
    function init() {
        console.log('%cPropeller', 'color: rgb(7, 30, 76);font-size: 60px;font-weight: bold;text-shadow: 1px 1px 5px rgb(111, 146, 203);');
    }

    /** document ready */
    docReady(init);
}(utilities, document));
